import { PETS_APIS } from "@/api_framework/api_config";
import { ICustomerPetListPet, ICustomerPetListResponse } from "@/api_framework/api_modals/Pets";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setCustomerPets, setPetDetails, setPetId } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});
type PetDetailsFetchOptionsType = {
  petId?: string;
  selectFirstPet?: boolean;
};

export const useCustomerPetListAPI = () => {
  const dispatch = useAppDispatch();
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const setPetDetailsData = (pets: ICustomerPetListPet[], petId?: string) => {
    const filteredPets = pets?.filter((pet) => pet.id === petId);
    if (filteredPets?.length > 0) {
      const selectedPet = filteredPets[0];
      dispatch(
        setCustomerPets({
          pets: pets,
        }),
      );
      dispatch(
        setPetDetails({
          petDetails: selectedPet,
        }),
      );
    } else {
      dispatch(
        setCustomerPets({
          pets: [],
        }), 
      );
      dispatch(
        setPetDetails({
          petDetails: null,
        }),
      );
    }
  };

  const toggleLoadingState = (toggleState: boolean) => {
    dispatch(
      setLoading({
        key: "isPetListFetchInProgress",
        status: toggleState,
      }),
    );
  };

  const execute = useCallback(async (userId: string, options?: PetDetailsFetchOptionsType) => {
    toggleLoadingState(true);
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(PETS_APIS?.LIST_PETS?.baseURL ?? "", {
          params: {
            user_id: userId,
          },
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<ICustomerPetListResponse>) => {
          toggleLoadingState(false);
          if (res.data.status === true) {
            let selectedPetId = "";
            if (options?.petId) {
              selectedPetId = options?.petId;
            }
            if (options?.selectFirstPet === true) {
              selectedPetId = res.data.data.all_pets[0]?.id;
              dispatch(
                setPetId({
                  petId: selectedPetId,
                }),
              );
            }
            setPetDetailsData(res.data.data.all_pets, selectedPetId);
          } else {
            setPetDetailsData([], null);
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          toggleLoadingState(false);
          setPetDetailsData([], null);
          if (e.response.status === 400) {
            toast.error("Pet Fetch API Failed");
          }
        });
    } catch (e: any) {
      toast.error("Customer pets cannot be fetched " + e.message);
    }
  }, []);
  return execute;
};
